module.exports = __webpack_public_path__ + "img/制御工学1_1.9e53e492.png";